// The SavaQuan iPhone app, as the web reaches it. Both values are build-time
// config per environment: REACT_APP_IOS_APP_SCHEME is the app's own URL scheme
// (savaquan, savaquan-staging), REACT_APP_IOS_APP_STORE_ID its App Store id.
// Without an id nothing points at the App Store (no Smart App Banner either,
// public/index.html); there is none until the App Store record exists.

const value = (raw: string | undefined) => raw?.trim() || undefined;

export const iosAppScheme = () => value(process.env.REACT_APP_IOS_APP_SCHEME);

export const iosAppStoreId = () => {
  const id = value(process.env.REACT_APP_IOS_APP_STORE_ID);
  return id && /^\d+$/.test(id) ? id : undefined;
};

/** The app's App Store page, or undefined until the app has one. */
export const iosAppStoreUrl = () => {
  const id = iosAppStoreId();
  return id ? `https://apps.apple.com/app/id${id}` : undefined;
};

/** A positive whole-number id from a query value, else undefined. */
export const linkId = (raw: string | null) => (raw && /^\d+$/.test(raw.trim()) && Number(raw) > 0 ? Number(raw) : undefined);

/**
 * The app's measure screen for a work item, on the app's scheme. The app
 * signs in on its own, so the link carries no token. Undefined when this
 * build has no scheme or an id is missing.
 */
export const iosMeasureTreeUrl = (estimateId?: number, treeId?: number) => {
  const scheme = iosAppScheme();
  if (!scheme || !estimateId || !treeId) {
    return undefined;
  }
  return `${scheme}://measure-tree?estimate-id=${estimateId}&tree-id=${treeId}`;
};
